<template>
  <div class="Site PageBox">
    <van-nav-bar
      fixed
      :border="false"
      :title="$t('lineList[0]')"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div class="ScrollBox">
      <van-cell class="mt15" size="large" :title="$t('lineList[1]')" :value="currLine|ellipsisVal" />
      <van-radio-group v-model="currLine" @change="selectLine">
        <van-cell v-for="(item,index) in InitData.link" :key="index" clickable>
          <template #title>
            {{$t('lineList[2]')}} {{item|ellipsisVal}}
            <i>{{timeList[index]}} ms</i>
          </template>
          <van-radio #right-icon :name="item" />
        </van-cell>
      </van-radio-group>
    </div>
  </div>
</template>
<script>
import Ping from 'web-pingjs'
export default {
  name: 'Lines',
  components: {

  },
  props: {},
  data() {
    return {
      listData: '',
      timeList: [],
      currLine: localStorage['ApiUrl']||ApiUrl,
      isStore: false,
    }
  },
  computed: {

  },
  filters: {
    ellipsisVal(val){
      return val.replace(/(\S*)\/\//,'').replace(/^(.{4}).*(.{4})$/, "$1***$2");
    }
  },
  watch: {

  },
  created() {
    this.pingLine(this.$store.state.InitData.link)
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    pingLine(line) {
      this.timeList = [];
      line.forEach((host)=>{
        Ping(host).then((time)=> {
          this.timeList.push(time)
        }).catch((err)=> {
          this.timeList.push('-')
        })
      });
    },
    selectLine(url) {
      console.log(url)
      this.currLine = url
      this.UpdateApiUrl(url)
      this.$Model.GetBackData()
    },
  }
}
</script>
<style scoped>
.van-cell__value{
  flex: none;
}
.van-cell__title i{
  color: #1989fa;
  margin-left: 15px;
}
.van-radio{
  justify-content: flex-end;
}
</style>